import { createSlice } from '@reduxjs/toolkit';

interface AdminState {
  userId: string;
}

const initialState: AdminState = {
  userId: "",
};

export const selectUserId = (state: any) => state.admin.userId;

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setUserId: (state, action) => {
        state.userId = action.payload;
    }
  }
});

export default adminSlice.reducer;